<template>
  <div class="order-history-section__box">
    <div class="order-history-section__date-area">
      <div class="order-history-section__date body">
        {{ formattedCreatedDate }}
      </div>
    </div>
    <div class="order-history-section__ticket-area">
      <div class="order-history-section__ticket">
        <ticket-detail-for-purchase-history
          :link-url="
            `/items/${itemSkuContent.itemId}/item_skus/${itemSkuContent.itemSkuId}`
          "
          :image-url="itemSkuContent.imageUrl"
          :item-name="itemSkuContent.itemName"
          :item-sku-name="itemSkuContent.itemSkuName"
          :brand-name="itemSkuContent.brandName"
          :is-ticket-expired="false"
          :other-item-sku-contents-count="otherItemSkuContentsCount"
        />
      </div>
    </div>
    <div class="order-history-section__message-wrap-area">
      <div class="order-history-section__message-area message--min">
        <div class="order-history-section__message">
          {{ message }}
        </div>
      </div>
    </div>
    <div class="order-history-section__button-area">
      <button
        class="btn-multi btn-multi--single chevron--forward--black order-history-section__button"
        @click="moveOrderDetail"
      >
        詳細を見る
      </button>
    </div>
  </div>
</template>

<script>
import TicketDetailForPurchaseHistory from '../../../atoms/tickets/TicketDetailForPurchaseHistory'
import dayjs from 'dayjs'

export default {
  components: {
    TicketDetailForPurchaseHistory
  },
  props: {
    id: {
      type: Number,
      require: true,
      default: 0
    },
    orderCode: {
      type: String,
      require: true,
      default: ''
    },
    message: {
      type: String,
      require: true,
      default: ''
    },
    createdAt: {
      type: String,
      require: true,
      default: ''
    },
    itemSkuContent: {
      type: Object,
      require: true,
      default: () => {}
    },
    itemSkuContentsCount: {
      type: Number,
      require: true,
      default: 1
    }
  },
  computed: {
    formattedCreatedDate() {
      return dayjs(this.createdAt).format('YYYY/MM/DD HH:mm')
    },
    otherItemSkuContentsCount() {
      return this.itemSkuContentsCount - 1
    },
    displayableOtherItemSkuContentsCount() {
      return this.otherItemSkuContentsCount >= 1
    }
  },
  methods: {
    moveOrderDetail() {
      location.href = `/mypage/order_histories/${this.orderCode}`
    }
  }
}
</script>
